import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { BannerService } from '../banners/banner.service';
import { setupNetworkConnectivity } from './network-connectivity';

export function provideNetworkConnectivity(): EnvironmentProviders {
  return provideAppInitializer(() => setupNetworkConnectivity(inject(BannerService)));
}
